import { RootState } from "../store/community-finder-redux-store";

export const selectIsMobileCardOpen = (state: RootState) => 
    state?.appStatus?.isMobileCardOpen;
